export function isBoxUploadEnabled() {
    return import.meta.env.VITE_FEATURE_BOX_UPLOAD === 'true';
}

export function getBoxUploadTestSalesforceIds(): string[] {
    const raw = import.meta.env.VITE_BOX_UPLOAD_TEST_SALESFORCE_IDS ?? '';
    return String(raw)
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);
}

export function isBoxUploadTestOpportunity(oppId?: string | null): boolean {
    if (!oppId) return false;
    return getBoxUploadTestSalesforceIds().includes(oppId);
}

export function isBoxUploadEnabledForOpportunity(oppId?: string | null): boolean {
    return isBoxUploadEnabled() || isBoxUploadTestOpportunity(oppId);
}

export function showModulePlacementStatus() {
    return import.meta.env.VITE_FEATURE_MODULE_PLACEMENT_MESSAGE === 'true';
}
